import "./CellDetails.css"

interface CellDetailsProps {
    title: string | number
    description?: string | number | boolean
    details?: string | number | boolean
    align?: "left" | "center" | "right"
}

const CellDetails = ({ title, description, details, align = "left" }: CellDetailsProps) => {
    return (
        <div className={`cell-details cell-details--${align}`}>
            <span className="cell-details__title">{title}</span>
            {description !== undefined && description !== "" && (
                <span className="cell-details__description">{description}</span>
            )}
            {details !== undefined && details !== "" ? (
                <span className="cell-details__title">{details}</span>
            ) : <br />}
        </div>
    )
}

export default CellDetails
